import type { InternalRequest } from '../client.js';

export interface Poi {
  id: string;
  name: string;
  description?: string | null;
  latitude: number;
  longitude: number;
  radius_meters: number | null;
  category_id?: string | null;
  color?: string | null;
  icon?: string | null;
}

export function poisEndpoints(req: InternalRequest) {
  return {
    /** GET /pois — org POIs (read-only; org-scoped server-side). */
    list: () => req.request<Poi[]>('/pois'),
    /** GET /pois/categories */
    categories: () => req.request<unknown[]>('/pois/categories'),
  };
}
